export default __webpack_public_path__ + "static/media/Death's Ward.8b71c3a1.jpg";